/*
 * ATTENTION!!! Read this rule before writing action types.
 *
 *  AUTH_                 -> Reducer
 *  _USER_                -> User role / Optional
 *  _ACTION_NAME_         -> Action
 */

// NOTIFICATION
export const NOTIFICATION_POP_NOTIFY = 'NOTIFICATION_POP_NOTIFY' as const;
export const NOTIFICATION_PUSH_NOTIFY = 'NOTIFICATION_PUSH_NOTIFY' as const;

// AUTH
export const AUTH_LOGIN = 'AUTH_LOGIN' as const;
export const AUTH_LOGIN_AS = 'AUTH_LOGIN_AS' as const;
export const AUTH_AUTH0_LOGIN = 'AUTH_AUTH0_LOGIN' as const;
export const AUTH_LOGOUT = 'AUTH_LOGOUT' as const;
export const AUTH_REGISTER_USER = 'AUTH_REGISTER_USER' as const;
export const AUTH_CREATE_PASSWORD = 'AUTH_CREATE_PASSWORD' as const;
export const AUTH_RP_SEND_EMAIL = 'AUTH_RP_SEND_EMAIL' as const;
export const AUTH_RP_UPDATE = 'AUTH_RP_UPDATE' as const;
export const AUTH_SET_ANONYMOUS_ID = 'AUTH_SET_ANONYMOUS_ID' as const;

// REPORTS
export const REPORTS_GET_LIST = 'REPORTS_GET_LIST' as const;
export const REPORTS_GET_DETAILS = 'REPORTS_GET_DETAILS' as const;
export const REPORTS_CLEAN_DETAILS = 'REPORTS_CLEAN_DETAILS' as const;
export const REPORTS_GENERATE_REPORT = 'REPORTS_GENERATE_REPORT' as const;
export const REPORTS_SET_USER_FIELDS = 'REPORTS_SET_USER_FIELDS' as const;
export const REPORTS_GET_DICTIONARY = 'REPORTS_GET_DICTIONARY' as const;
export const REPORTS_GET_SCHEDULE_SETTINGS = 'REPORTS_GET_SCHEDULE_SETTINGS' as const;
export const REPORTS_SAVE_SCHEDULE_SETTINGS = 'REPORTS_SAVE_SCHEDULE_SETTINGS' as const;
export const REPORTS_EXTEND_INVITE = 'REPORTS_EXTEND_INVITE' as const;

// SR USERS
export const SR_USERS_GET_DETAILS = 'SR_USERS_GET_DETAILS' as const;
export const SR_USERS_CLEAN_DETAILS = 'SR_USERS_CLEAN_DETAILS' as const;
export const SR_USERS_GET_PAYMENTS = 'SR_USERS_GET_PAYMENTS' as const;
export const SR_USERS_SEND_TRANSFER_REQUEST = 'SR_USERS_SEND_TRANSFER_REQUEST' as const;

// USERS
export const USERS_GET_LIST = 'USERS_GET_LIST' as const;
export const USERS_CLEAN_LIST = 'USERS_CLEAN_LIST' as const;
export const USERS_ADD_USER = 'USERS_ADD_USER' as const;
export const USERS_UPDATE_USER = 'USERS_UPDATE_USER' as const;
export const USERS_ACTIVATE_USER = 'USERS_ACTIVATE_USER' as const;

// PROFILES
export const PROFILES_GET_LIST = 'PROFILES_GET_LIST' as const;
export const PROFILES_CLEAN_LIST = 'PROFILES_CLEAN_LIST' as const;
export const PROFILES_LOGIN_AS_USER = 'PROFILES_LOGIN_AS_USER' as const;

// CHARTS
export const CHARTS_GET_PERIODS = 'CHARTS_GET_PERIODS' as const;
export const CHARTS_GET_LIST = 'CHARTS_GET_LIST' as const;
export const CHARTS_CLEAN_LIST = 'CHARTS_CLEAN_LIST' as const;

// DICTIONARY
export const DICTIONARY_GET = 'DICTIONARY_GET' as const;

// WEBHOOKS
export const WEBHOOKS_GET_DICTIONARY = 'WEBHOOKS_GET_DICTIONARY' as const;
export const WEBHOOKS_ADD_CUSTOMER_CREDITS = 'WEBHOOKS_ADD_CUSTOMER_CREDITS' as const;
export const WEBHOOKS_UPDATE_CUSTOMER_CREDITS = 'WEBHOOKS_UPDATE_CUSTOMER_CREDITS' as const;
export const WEBHOOKS_CANCEL_CUSTOMER_CREDITS = 'WEBHOOKS_CANCEL_CUSTOMER_CREDITS' as const;

// _____ WP BLOG
export const WP_BLOG_GET_PAGE = 'WP_BLOG_GET_PAGE' as const;

// SETTINGS
export const SETTINGS_GET_DICTIONARY = 'SETTINGS_GET_DICTIONARY' as const;
export const SETTINGS_UPDATE_DICTIONARY = 'SETTINGS_UPDATE_DICTIONARY' as const;
